module.exports = __webpack_public_path__ + "img/b6.e0ba6ad4.png";